module.exports = __webpack_public_path__ + "static/modify-search-12554f592bd2d167a47fd6ec05e72ced.svg";